/* =====================================================================
   HP Smooth Scroll — scorrimento morbido della pagina su computer.
   La rotella del mouse (o il trackpad) non sposta piu' la pagina a scatti:
   ogni movimento aggiunge strada a una destinazione e la pagina la raggiunge
   rallentando. Si usa lo scorrimento vero del browser (window.scrollTo),
   quindi testata fissa, elementi agganciati e caricamento pigro delle
   immagini continuano a funzionare come prima.

   Non interviene, e lascia fare al browser:
   - su telefono e tablet (lo scorrimento a dito ha gia' la sua inerzia);
   - con "riduci movimento" attivo nel sistema e nell'editor del tema;
   - dentro i pannelli che scorrono per conto loro (carrello, filtri, menu,
     risultati della ricerca) e sopra le finestre a tutto schermo;
   - a pagina bloccata (carrello, menu o ricerca aperti);
   - con Ctrl/Cmd (zoom) o Maiusc premuti e per i gesti orizzontali;
   - in cima e in fondo alla pagina (resta il rimbalzo del Mac).
   Tastiera, barra di scorrimento e collegamenti interni restano del browser.

   Si spegne da Impostazioni tema > Animazione > "Scorrimento morbido".
   ===================================================================== */
(function () {
  'use strict';
  if (window.__hpSmoothScroll) return;
  window.__hpSmoothScroll = true;
  if (!window.requestAnimationFrame || !window.matchMedia) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var FRENATA = 8;       /* 1/s: piu' alto = piu' pronto; piu' basso = scia piu' lunga */
  var PASSO_RIGA = 32;   /* px per "riga" quando il browser misura la rotella in righe (Firefox) */
  var SENZA_FOTOGRAMMI = 250; /* ms: se il browser non disegna, niente animazione */

  var root = document.documentElement;
  var conMouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  var menoMovimento = window.matchMedia('(prefers-reduced-motion: reduce)');

  var attuale = 0, meta = 0, scritto = 0;
  var inCorso = false, tempoFotogramma = 0, timerRiserva = 0;
  var bersaglio = null, esitoBersaglio = false, tempoBersaglio = 0;

  function adesso() { return window.performance && performance.now ? performance.now() : Date.now(); }
  function posizione() { return window.pageYOffset || root.scrollTop || 0; }
  function fondo() { return Math.max(0, root.scrollHeight - root.clientHeight); }

  function scrivi(y) {
    scritto = y;
    try {
      window.scrollTo({ top: y, left: window.pageXOffset || 0, behavior: 'instant' });
    } catch (err) {
      window.scrollTo(window.pageXOffset || 0, y);
    }
  }

  function ferma() {
    inCorso = false;
    clearTimeout(timerRiserva);
    attuale = meta = posizione();
  }

  /* Carrello e menu bloccano la pagina con position:fixed sul body, la ricerca con i suoi eventi
     (classe hp-so-open), altri pannelli con overflow:hidden: in tutti i casi non si scorre. */
  function paginaBloccata() {
    var body = document.body;
    if (!body) return true;
    if (root.classList.contains('hp-so-open')) return true;
    var sb = getComputedStyle(body);
    if (sb.position === 'fixed' || sb.overflowY === 'hidden') return true;
    return getComputedStyle(root).overflowY === 'hidden';
  }

  /* Il puntatore e' sopra qualcosa che scorre da se' o sopra una finestra a tutto schermo? */
  function lasciaAlBrowser(el) {
    var ora = adesso();
    if (el === bersaglio && ora - tempoBersaglio < 300) return esitoBersaglio;
    bersaglio = el;
    tempoBersaglio = ora;
    esitoBersaglio = false;
    var n = el && el.nodeType === 1 ? el : null;
    while (n && n !== document.body && n !== root) {
      var tag = n.tagName;
      if (tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'IFRAME' || (tag === 'INPUT' && n.type === 'number')) {
        esitoBersaglio = true;
        break;
      }
      var st = getComputedStyle(n);
      var oy = st.overflowY;
      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && n.scrollHeight > n.clientHeight + 1) {
        esitoBersaglio = true;
        break;
      }
      if (st.position === 'fixed' && n.getBoundingClientRect().height >= window.innerHeight * .5) {
        esitoBersaglio = true;
        break;
      }
      n = n.parentElement;
    }
    return esitoBersaglio;
  }

  function passo(ora) {
    if (!inCorso) return;
    var dt = tempoFotogramma ? Math.min(Math.max(ora - tempoFotogramma, 0), 64) / 1000 : 1 / 60;
    tempoFotogramma = ora;
    attuale += (meta - attuale) * (1 - Math.exp(-FRENATA * dt));
    if (Math.abs(meta - attuale) < .5) {
      attuale = meta;
      inCorso = false;
      clearTimeout(timerRiserva);
    }
    scrivi(attuale);
    if (inCorso) requestAnimationFrame(passo);
  }

  /* Scheda in secondo piano o browser che non disegna: i fotogrammi non arrivano e la pagina
     resterebbe ferma. In quel caso si va subito a destinazione, senza animazione. */
  function riserva() {
    if (!inCorso) return;
    if (adesso() - tempoFotogramma < SENZA_FOTOGRAMMI) {
      timerRiserva = setTimeout(riserva, SENZA_FOTOGRAMMI);
      return;
    }
    attuale = meta;
    inCorso = false;
    scrivi(meta);
  }

  function suRotella(e) {
    if (e.defaultPrevented || e.ctrlKey || e.metaKey || e.shiftKey) return;
    if (!conMouse.matches || menoMovimento.matches) return;
    var dy = e.deltaY;
    if (!dy || Math.abs(e.deltaX) > Math.abs(dy)) return;
    if (lasciaAlBrowser(e.target) || paginaBloccata()) {
      if (inCorso) ferma();
      return;
    }
    if (e.deltaMode === 1) dy *= PASSO_RIGA;
    else if (e.deltaMode === 2) dy *= root.clientHeight * .9;

    if (!inCorso) attuale = meta = posizione();
    var nuova = Math.min(fondo(), Math.max(0, meta + dy));
    if (nuova === meta && !inCorso) return; /* gia' in cima o in fondo */
    e.preventDefault();
    meta = nuova;
    if (!inCorso) {
      inCorso = true;
      tempoFotogramma = 0;
      requestAnimationFrame(passo);
    }
    if (!tempoFotogramma) tempoFotogramma = adesso();
    clearTimeout(timerRiserva);
    timerRiserva = setTimeout(riserva, SENZA_FOTOGRAMMI);
  }

  /* Barra di scorrimento, tastiera, collegamenti interni o altri script possono spostare la pagina:
     a riposo ci si riallinea, durante l'animazione si cede il passo. */
  function suScorrimento() {
    if (!inCorso) {
      attuale = meta = posizione();
      return;
    }
    if (Math.abs(posizione() - scritto) > 3) ferma();
  }

  window.addEventListener('wheel', suRotella, { passive: false });
  window.addEventListener('scroll', suScorrimento, { passive: true });
})();
